import React from 'react'
import { URL_SRV_ARIZTIA } from '../../router/Url';

export const GetDataToFactureSelect = ({EMPRESA, TIPO=null, ANNIO=null}) => {//getdatatoselectfacture
    return new Promise(async (resolve, reject) => {
        let query = await fetch(URL_SRV_ARIZTIA+'getdatatoselectfacture',{
          method: 'POST',
          headers: {
            'authorization': "paico2021",
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            EMPRESA,TIPO,ANNIO
          })
        })
        let responsito = await query.json();
        // console.log(responsito)
        if(responsito.success){
          resolve(responsito.body)
        }else{
          resolve([])
        }
      })
}
